/**
 * Create a custom image loader for Contentful images that will automatically
 * convert images to webp and resize them if indicated.
 */ const createContentfulImageLoader = (resize)=>(props)=>{
        const { src, quality, width } = props;
        const urlObject = new URL(src);
        urlObject.searchParams.set('fm', 'webp');
        if (quality) {
            urlObject.searchParams.set('q', String(quality));
        }
        /**
   * TODO: [WCDS] Implement a max size functionality in order to reduce page weight
   */ if (resize) {
            urlObject.searchParams.set('w', String(width));
        }
        return urlObject.toString();
    };

export { createContentfulImageLoader };
